export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8789.302277dd.jpg";